import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "./store";
import { router } from "./routes";
import { ToastProvider } from "./ui";
import ToastListener from "./components/ToastListener";
import { initializeAuthToken, fetchBrandConfig, decodeTokenBrandSlug } from "./services/api";
import { setBrandConfig } from "./store/slices/brandSlice";

function App() {
  useEffect(() => {
    const token = initializeAuthToken();
    // Decode brand_slug from stored token so WL admins see their brand on app load.
    // Superadmins have an empty/null brand_slug — explicitly request the main brand
    // (esim101) so the console never falls back to a white-label palette.
    const brandSlug = token ? decodeTokenBrandSlug(token) : null;
    const effectiveSlug = brandSlug || "esim101";

    fetchBrandConfig(effectiveSlug)
      .then((cfg) => {
        if (cfg.primary_color) {
          document.documentElement.style.setProperty("--color-primary", cfg.primary_color);
        }
        if (cfg.secondary_color) {
          document.documentElement.style.setProperty("--color-secondary", cfg.secondary_color);
        }
        if (cfg.logo_url) {
          document.documentElement.style.setProperty("--brand-logo-url", `url(${cfg.logo_url})`);
        }
        store.dispatch(
          setBrandConfig({
            name: cfg.name || "eSIM Console",
            logoUrl: cfg.logo_url,
            primaryColor: cfg.primary_color,
            secondaryColor: cfg.secondary_color,
          })
        );
      })
      .catch(() => {
        // Non-critical: keep defaults
      });
  }, []);

  return (
    <Provider store={store}>
      <ToastProvider>
        <RouterProvider router={router} />
        <ToastListener />
      </ToastProvider>
    </Provider>
  );
}

export default App;
